import LandingPage from "@/Component/LandingPage";
import LoginPage from "./(Auth)/login/page";

export default function Home() {
  return (
    <LoginPage />
  );
}
